export default "__VITE_ASSET__BSC1hpCp__"